export interface AccommodationType {
  value: string;
  labelId: string;
  group: string
}

export const groups: string[] = ["flat", "house", "rooms","luxury", "interesting", "others", "all"]

export const accommodationTypes: AccommodationType[] = [
    { value: "apartment", labelId: "apartment", group: "flat" },
    { value: "bungalow", labelId: "bungalow", group: "house" },
    { value: "cabin", labelId: "cabin", group: "interesting" },
    { value: "caravan", labelId: "caravan", group: "interesting" },
    { value: "chalet", labelId: "chalet", group: "luxury" },
    { value: "condo", labelId: "condo", group: "flat" },
    { value: "cottage", labelId: "cottage", group: "house" },
    { value: "dorm", labelId: "dorm", group: "interesting" },
    { value: "duplex", labelId: "duplex", group: "house" },
    { value: "farmhouse", labelId: "farmhouse", group: "interesting" },
    { value: "house-single-family", labelId: "house-single-family", group: "house" },
    { value: "house-semi-detached", labelId: "house-semi-detached", group: "house" },
    { value: "houseboat", labelId: "houseboat", group: "interesting" },
    { value: "loft", labelId: "loft", group: "interesting" },
    { value: "mansion", labelId: "mansion", group: "luxury" },
    { value: "motorhome", labelId: "motorhome", group: "interesting" },
    { value: "room-in-apartment", labelId: "room-in-apartment", group: "rooms" },
    { value: "room-in-house", labelId: "room-in-house", group: "rooms" },
    { value: "rowhouse", labelId: "rowhouse", group: "house" },
    { value: "studio", labelId: "studio", group: "flat" },
    { value: "suite", labelId: "suite", group: "luxury" },
    { value: "tent", labelId: "tent", group: "interesting" },
    { value: "townhouse", labelId: "townhouse", group: "house" },
    { value: "urban", labelId: "urban", group: "interesting" },
    { value: "villa", labelId: "villa", group: "luxury" },
    { value: "other", labelId: "other", group: "others" },
];
